export function getSchedulesPaintPerformanceKey(
  tag: "NavigateStart" | "Paint",
  routeIndex?: number,
  routeSegmentIndex?: number,
) {
  return `Schedule${tag}-${routeIndex}-${routeSegmentIndex}`;
}
